import { setGlobalPageStatus } from 'store/app/app.actions';
import { persistanceManager } from 'services/persistanceManager';
import * as Logger from 'services/logger';
import listenToLoaderMessages from 'store/middleware/chat/loaderListener';
import { setAutoTranslateLanguage } from 'store/app/app.actions';
import { getNonce } from 'utils';
import { bchatRetry } from '@missionlabs/smartagent-bchat';
import { IChatSessionParams } from './chatSession';

const getChatSession = async ({
    ws,
    connectionDetails,
    store,
    globalRestoreSession,
    startDisconnectChatFlow,
}: IChatSessionParams) => {
    const { getPersistanceContactId, deletePersistanceContactId, getGlobalPageStatus } =
        persistanceManager(connectionDetails.contactFlowId, globalRestoreSession);

    const existingContactId = await getPersistanceContactId();
    const globalPageStatus = await getGlobalPageStatus();
    store.dispatch(setGlobalPageStatus(globalPageStatus));

    if (!existingContactId) return

    try {
        if (globalRestoreSession) {
            const session = await ws.describeContactEvent(existingContactId);
            if (session?.Contact?.DisconnectTimestamp) throw new Error()
        }

        if (startDisconnectChatFlow) throw new Error('no existing chat session present');

        listenToLoaderMessages(store);

        const { participantToken, participantId, contactId, region, translationLanguage } =
            await ws.getChatSession(existingContactId, 'CUSTOMER');

        const session = connect.ChatSession.create({
            chatDetails: {
                contactId,
                participantId,
                participantToken,
            },
            type: connect.ChatSession.SessionTypes.CUSTOMER,
            options: {
                region,
                nonce: getNonce(),
            },
        });

        await bchatRetry(async () => await session.connect(), (timesRetried, error) => {
            Logger.warn(`session.connect retried. Times: ${timesRetried}`, error)
        }).catch(async err => {
            await window.bchat.putMetric({ metricName: 'Error/Connect/RetryFailed' })
            throw err
        });

        if (translationLanguage) store.dispatch(setAutoTranslateLanguage(translationLanguage));
        return session;
    } catch (error) {
        if (typeof error === 'string') Logger.error(error);
        deletePersistanceContactId();
        return
    }
};

export default getChatSession